export default {"src":"/_next/static/media/xk.2d81d1e5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};